import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import { connect } from 'react-redux';
import { compose } from 'redux';

const Job = ({
  job,
  classes,
}) => (
  <div key={job.id} className={classes.job}>
    <div className={classes.title}>
      <a href={job.url} target="_blank" rel="noopener noreferrer" className={classes.link}>
        {job.title}
      </a>
    </div>

    <div className={classes.location}>
      {job.location}
    </div>
  </div>
);

Job.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  job: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  ...state,
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    title: {
      lineHeight: '150%',
    },
    link: {
      textDecoration: 'none',
      borderBottom: '1px solid #000',
    },
    job: {
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '24px',
      padding: '12px 0px 12px 0px',
    },
    location: {
      fontSize: '16px',
      fontWeight: '400',
    },
  }),
)(Job);
